import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { LTSContext } from '../../context/LTSContext';
import TrainSelect from './components/TrainSelect/TrainSelect.component';
import NewFooter from '../../components/NewFooter/NewFooter.component';
import HTMLHead from '../../components/HTMLHead/HTMLHead.component';
import '../../../../styles/LTSLanding.css';
import { getNewTrainSearchHistory, redirectToLiveTrainPage, saveTrainRecentSearch } from '../../utils/LTSUtils';
import SEOContent from '../../components/SEOContent/SEOContent.component';
import FAQContent from '../../components/FAQContent/FAQContent.component';

const LTSLanding = (props) => {
  const { data } = props;

  const ltsContext = useContext(LTSContext);
  const { recentSearchTrains, trainDetail, setRecentSearchTrains } = ltsContext;

  const handleCheckStatus = () => {
    if (!trainDetail?.trainNumber) {
      return;
    } else {
      setTimeout(() => {
        if (trainDetail?.trainNumber) {
          const recentSearchTrainsVar = getNewTrainSearchHistory(trainDetail, recentSearchTrains);
          setRecentSearchTrains(recentSearchTrainsVar);
          saveTrainRecentSearch(recentSearchTrainsVar);
        }
      }, 0);
      const requestDetails = {
        trainDetail: trainDetail
      };
      redirectToLiveTrainPage(requestDetails);
    }
  };

  return (
    <Fragment>
      <HTMLHead data={data} />
      <main className="LTSLanding-main-wrapper">
        <div className="LTSLanding-top-section">
          <div className="LTSBackgroundBanner">
            <div className="LTSContentWpr">
              <h1 className="LTSLanding-header">Train Running Status</h1>
              <TrainSelect handleCheckStatus={handleCheckStatus} />
            </div>
          </div>
        </div>
        <div className="LTSLanding-mid-section">
          <SEOContent />
          <FAQContent />
        </div>
        <NewFooter />
      </main>
    </Fragment>
  );
};

LTSLanding.propTypes = {
  data: PropTypes.object
};

export default LTSLanding;
